import { dataTrack } from "./functions"

// learn_more_clicked
const setLearnMoreClickedEvent = (data)  => {

  const { url, referrer, name } = data

  dataTrack('learn_more_clicked', {
    'click_url': url,
    'button_name': name,
    'referrer': referrer
  })
}

// contact_us_form_submitted
const setContactUsFormSubmittedEvent = (data)  => {

  const { topicId, topicName, batchn, sop, pt, pq, contact_us_flavor_name } = data

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': 'contact_us_form_submitted',
    'topic_id': topicId,
    'topic_name': topicName,
    'dtls': {
      'cus': {
        'batchn': batchn,
        'sop': sop,
        'pt': pt,
        'pq': pq,
        'contact_us_flavor_name': contact_us_flavor_name
      }
    }
  })
}

// social_post_clicked
const setSocialPostClickedEvent = (data) =>{

  const { link, position } = data

  dataTrack('social_post_clicked', {
    'outbound_link': link,
    'tile_position': position
  })
}

// more_products_viewed
const setMoreProductsViewedEvent = (data)  => {

  const { arrow, url } = data

  dataTrack('more_products_viewed', {
    'arrow': arrow,
    'page_url': url
  })
}

// product_flavor_clicked
const setProductFlavorClickedEvent = (data) =>{

  const {flavor, category, position, url, location, size} = data

  dataTrack('product_flavor_clicked', {
    'product_flavor': flavor,
    'product_category': category,
    'product_position': position,
    'page_url': url,
    'page_location': location,
    'product_size': size
  })
}

// product_flavor_viewed
const setProductFlavorViewedEvent = (data) =>{

  const {flavor, category, size} = data

  dataTrack('product_viewed', {
    'page_category': 'PDP',
    'product_flavor': flavor,
    'product_category': category,
    'product_size': size
  })
}

// social_icon_clicked
const setSocialIconClickedEvent = (data) =>{

  const { platform, location } = data

  dataTrack('social_icon_clicked', {
    'social_platform': platform,
    'page_location': location
  })
}

// global lang and country
const setGlobalLangAndCountryEvent = (lang) => {
  dataTrack(undefined, {
    'country': 'CA',
    'language': lang
  })
}

// nutrition_ingredients_clicked
const setNutritionIngClickedEvent = (product)  => {
  dataTrack('nutrition_ingredients_clicked', {
    'product_flavor': product.name,
    'product_category': product.category
  })
}

// category_viewed
const setCategoryViewedEvent = (data) =>{

  const {category, tab } = data

  dataTrack('category_viewed', {
    'product_category': category,
    'view_by_section': tab
  })
}

// faq_title_clicked
const setFAQTitleClickedEvent = (title) =>{

  dataTrack('faq_title_clicked', {
    'faq_title': title
  })
}

// view_by_selection
const setViewByRangeEvent = (data) => {
  dataTrack('view_by_selection', {
    'view_by_selection': data
  })
}

// play_video_clicked
const setPlayVideoClickedEvent = (data) => {

  const { videoUrl, pageLocation } = data

  dataTrack('play_video_clicked', {
    'page_url': videoUrl,
    'page_location': pageLocation
  })
}

// faq_viewed
const setFAQViewedEvent = (url) =>{
  dataTrack('faq_viewed', {
    'referrer': url
  })
}

export {
  setLearnMoreClickedEvent,
  setContactUsFormSubmittedEvent,
  setSocialPostClickedEvent,
  setMoreProductsViewedEvent,
  setProductFlavorClickedEvent,
  setProductFlavorViewedEvent,
  setSocialIconClickedEvent,
  setGlobalLangAndCountryEvent,
  setNutritionIngClickedEvent,
  setCategoryViewedEvent,
  setFAQTitleClickedEvent,
  setViewByRangeEvent,
  setPlayVideoClickedEvent,
  setFAQViewedEvent
}